<template>
  <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.15.4/css/all.min.css">
  <div dir="rtl" class="min-h-screen flex flex-col">
    <TheHeader :user="user" :toggleMenu="toggleMenu" :isMenuOpen="isMenuOpen" :user_manual_url="user_manual_url"/>
    <main class="flex-grow">
      <NuxtPage v-if="!isMenuOpen"/>
    </main>
    <TheFooter/>
  </div>
</template>

<script>
import TheHeader from "./components/header/TheHeader.vue";
import TheFooter from "./components/TheFooter.vue";
import {getUserData} from "~/services/individual/user.js";

export default {
  data() {
    return {
      user: {},
      isMenuOpen: false,
      user_manual_url: ''
    }
  },
  components: {
    TheHeader, TheFooter
  },
  mounted() {
    this.fetchUserData();
  },
  methods: {
    fetchUserData() {
      getUserData().then(result => {
        this.user.isAuthenticated = result.logged_in;
        this.user_manual_url = result.user_manual_url
        if (result.logged_in) {
          this.user.menuItems = result.menu_items;
          this.user.name = result.first_name;
        }
      });
    },
    toggleMenu() {
      this.isMenuOpen = !this.isMenuOpen;
    },
  }
}
</script>
